/**
 * Formats a date string or Date object into Japanese date format (YYYY年M月D日).
 * Returns an empty string if the input is invalid or empty.
 *
 * @param dateStr - The date as a string or Date object.
 * @returns The formatted date string in Japanese format, or an empty string if invalid.
 */
export function JapaneseDateformat(dateStr: string | Date): string | null {
  if (!dateStr) return null;

  const date: Date = new Date(dateStr);
  if (isNaN(date.getTime())) return null; // invalid date

  const year: number = date.getFullYear();
  const month: number = date.getMonth() + 1; // months are 0-indexed
  const day: number = date.getDate();

  return `${year}年${month}月${day}日`;
}